<template>
  <!--PORTFOLIO MODAL 1 - SWEETX PROJECT -->
  <div
    class="portfolio-modal modal fade"
    id="portfolioModal1"
    tabindex="-1"
    role="dialog"
    aria-labelledby="portfolioModal1Label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <button
          class="close btn btn-outline-light"
          type="button"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="fas fa-times"></i></span>
        </button>
        <div class="modal-body text-center">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <!-- Portfolio Modal - Title-->
                <h2
                  class="portfolio-modal-title text-secondary text-uppercase mb-5"
                  id="portfolioModal1Label"
                >
                  Sweetx E-commerce Website
                </h2>
                <!-- Portfolio Modal - Image-->
                <img
                  class="img-fluid rounded mb-5"
                  src="../../assets/sweetx-javaEE-project.png"
                  alt=""
                />
                <!-- Portfolio Modal - Text-->
                <p class="mb-5">
                  This website was created during our Design Patterns class as a
                  finals Project. Collaborating with
                  <a href="https://github.com/owenclamor">Owen Clamor</a>, we
                  have produced an great website for e-commerce using Java EE
                  Technology complete with a functioning cart-order system and
                  database. Click this
                  <a
                    href="https://github.com/nimbly-dev/school-projects/tree/master/SEG31-DESPATT-SAQUILAYAN_AND_CLAMOR-MP4"
                    >link</a
                  >
                  to redirect to the source code.
                </p>
                <button class="btn btn-primary" data-bs-dismiss="modal">
                  <i class="fas fa-times fa-fw"></i>
                  Close Window
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "portfolio-modal-one",
};
</script>

<style>
</style>